import config from '@/config'
import bus from '@/EventBus'

const baseURL = config.service.apiURL

const normalizePath = (path) => (path || '').replace(/^\/+/, '')

const buildURL = (path) => {
	if (/^https?:\/\//.test(path)) return path
	return baseURL + normalizePath(path)
}

const hasBody = (method) => ['post', 'put', 'patch'].includes((method || '').toLowerCase())

const buildHeaders = ({ method, path, body, headers = {} }) => {
	const token = localStorage.getItem('token')
	const requestPath = normalizePath(path)
	const nextHeaders = { ...headers }
	const isFormData = typeof FormData !== 'undefined' && body instanceof FormData

	if (requestPath !== 'login_check' && token) {
		nextHeaders.Authorization = `Bearer ${token}`
	}

	if (requestPath !== 'login_check' && !nextHeaders.Accept) {
		nextHeaders.Accept = 'application/ld+json'
	}

	if (hasBody(method) && !isFormData && !nextHeaders['Content-Type']) {
		nextHeaders['Content-Type'] =
			requestPath === 'login_check' ? 'application/json' : 'application/ld+json'
	}

	if (isFormData) {
		delete nextHeaders['Content-Type']
	}

	return nextHeaders
}

const parseBody = (response) => {
	const contentType = response.headers.get('content-type') || ''
	if (contentType.includes('application/json') || contentType.includes('application/ld+json')) {
		return response.json().catch(() => null)
	}
	return response.text().catch(() => '')
}

const createHttpError = ({ response, data, request }) => {
	const error = new Error(`HTTP ${response.status} for ${request.method} ${request.url}`)
	error.name = 'HttpError'
	error.status = response.status
	error.statusText = response.statusText
	error.data = data
	error.request = request
	return error
}

const request = (method, path, body, options = {}) => {
	const url = buildURL(path)
	const requestInit = {
		method: method.toUpperCase(),
		headers: buildHeaders({ method, path, body, headers: options.headers || {} })
	}

	const isFormData = typeof FormData !== 'undefined' && body instanceof FormData
	if (body !== undefined) {
		requestInit.body = isFormData || typeof body === 'string' ? body : JSON.stringify(body)
	}

	return fetch(url, requestInit)
		.then((response) =>
			parseBody(response).then((data) => {
				if (!response.ok) {
					if (response.status === 401) {
						bus.$emit('logout', 'Skończył się czas sesji. Proszę się ponownie zalogować.')
					}
					throw createHttpError({
						response,
						data,
						request: { method: requestInit.method, url }
					})
				}

				return {
					data,
					status: response.status,
					statusText: response.statusText,
					ok: response.ok,
					headers: response.headers
				}
			})
		)
		.catch((error) => {
			if (error && error.name === 'HttpError') throw error

			const networkError = new Error('Network request failed')
			networkError.name = 'NetworkError'
			networkError.request = { method: requestInit.method, url }
			networkError.cause = error
			throw networkError
		})
}

export default {
	get(path, options) {
		return request('get', path, undefined, options)
	},
	delete(path, options) {
		return request('delete', path, undefined, options)
	},
	post(path, body, options) {
		return request('post', path, body, options)
	},
	put(path, body, options) {
		return request('put', path, body, options)
	},
	patch(path, body, options) {
		return request('patch', path, body, options)
	}
}
